import { Flex, Text } from '@chakra-ui/react';
import React from 'react';

import IconSvg from 'ui/shared/IconSvg';

/**
 * Shared empty state. Upstream prints a bare <Text> ("There are no transactions."),
 * which makes every empty tab read as a broken page. Wired into DataListDisplay so
 * every list in the explorer gets the same treatment.
 */

interface Props {
  text: React.ReactNode;
  className?: string;
}

const BkcEmptyState = ({ text, className }: Props) => (
  <Flex
    className={ className }
    direction="column"
    alignItems="center"
    justifyContent="center"
    textAlign="center"
    py={{ base: 10, lg: 14 }}
    px={ 4 }
    mt={ 2 }
    borderWidth="1px"
    borderStyle="dashed"
    borderColor={{ _light: '#DCE6F5', _dark: 'border.divider' }}
    borderRadius="14px"
    bg={{ _light: '#FAFCFF', _dark: 'transparent' }}
  >
    <Flex
      w="52px"
      h="52px"
      borderRadius="full"
      alignItems="center"
      justifyContent="center"
      bg={{ _light: '#EDF4FE', _dark: 'whiteAlpha.100' }}
      mb={ 3 }
    >
      <IconSvg name="search" boxSize={ 6 } color="#8FB0E6"/>
    </Flex>
    <Text fontSize="sm" fontWeight={ 600 } color={{ _light: '#39568F', _dark: 'inherit' }}>
      { text }
    </Text>
    <Text fontSize="xs" color="text.secondary" mt={ 1 }>
      Nothing to show here yet.
    </Text>
  </Flex>
);

export default React.memo(BkcEmptyState);
